import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['navigationButton'];
  static outlets = ['reveal'];

  static values = {
    buttonActiveClass: {
      type: String,
      default: 'active',
    },
    buttonInactiveClass: {
      type: String,
      default: null,
    },
  };

  onSlideChanged({ indexh, indexv }) {
    this.navigationButtonTargets.forEach((button) => {
      const slideHIndex = parseInt(button.dataset.slideHIndex);
      const slideVIndex = parseInt(button.dataset.slideVIndex);

      if (slideHIndex === indexh && (slideVIndex === indexv || slideVIndex === 0 || slideVIndex === undefined)) {
        this.buttonActiveClassValue.split(' ').forEach((className) => {
          button.classList.add(className);
        });

        this.buttonInactiveClassValue.split(' ').forEach((className) => {
          button.classList.remove(className);
        });
      } else {
        this.buttonInactiveClassValue.split(' ').forEach((className) => {
          button.classList.add(className);
        });
        
        this.buttonActiveClassValue.split(' ').forEach((className) => {
          button.classList.remove(className);
        });
      }
    });
  }

  navigate({ target: { dataset } }) {
    this.revealOutlet.currentSlideIndexValue = [
      parseInt(dataset.slideHIndex),
      parseInt(dataset.slideVIndex || 0),
      parseInt(this.revealOutlet.currentSlideIndexValue[2]),
    ];
  }
}
